import { assertTrue, assertBoolean } from "../../../utils/assert";
import { EntityType, Division, PersonDraft, Person } from "../../../../models";
import { perparePersonDraft } from "../../../utils/draft";
import { EditStore } from "../EditCreate/EditStore";
import { names } from "./EditCreatePersonActions";
import { nameof } from "../../../utils/nameof";
import { names as editCreateNames } from "../../../actions/EditCreateEntityActions";

export interface EditCreatePersonStoreState
{
    draft: PersonDraft;
    divisions: Division[];
}

export class EditCreatePersonStore extends EditStore<PersonDraft, EditCreatePersonStoreState>
{
    constructor()
    {
        super ();

        this.register<number>(names.SET_DIVISION, e => this.draft({ DivisionRegId: e.payload }));
        this.register<Division[]>(names.SET_DIVISION_ITEMS, e => this.field({ divisions: e.payload }));

        this.register<string>(names.SET_FIRST_NAME, e => this.setFirstName(e.payload))
        this.register<string>(names.SET_LAST_NAME, e => this.setLastName(e.payload));
        this.register<string>(names.SET_USER_NAME, e => this.setUserName(e.payload));
        this.register<boolean>(names.SET_ADMIN_FLAG, e => this.setAdminFlag(e.payload));
        
        this.register<string>(names.SET_PASSWORD, e => this.setPassword(e.payload));
        this.register<string>(names.SET_PASSWORD_CONFIRMATION, e => this.setPasswordConfirmation(e.payload));
        
        this.register<Person>(editCreateNames.REJECT_DRAFT, e => {
            if(e.meta === EntityType.Person)
                return this.getDefaultStateFor(null);
        });
        this.register<Person>(editCreateNames.SET_EDIT_ENTITY, e => {
            if(e.meta === EntityType.Person)
                return this.getDefaultStateFor(e.payload);
        });
    }

    setFirstName = (firstName: string): EditCreatePersonStoreState => {
        assertString(firstName, nameof({ firstName }));
        return this.draft({ Firstname: firstName });
    }

    setLastName = (lastName: string): EditCreatePersonStoreState => {
        assertString(lastName, nameof({ lastName }));
        return this.draft({ Lastname: lastName });
    }

    setUserName = (userName: string): EditCreatePersonStoreState => {
        assertString(userName, nameof({ userName }));
        return this.draft({ Username: userName });
    }

    setAdminFlag = (isAdmin: boolean): EditCreatePersonStoreState => {
        assertBoolean(isAdmin, `${nameof({ isAdmin })} has to be a boolean value`);
        return this.draft({ IsAdministrator: isAdmin });
    }

    setPassword = (password: string): EditCreatePersonStoreState => {
        assertString(password, nameof({ password }));
        return this.draft({ Password: password });
    }

    setPasswordConfirmation = (passwordConfirmation: string): EditCreatePersonStoreState => {
        assertString(passwordConfirmation, nameof({ passwordConfirmation }));
        return this.draft({ PasswordConfirmation: passwordConfirmation });
    }

    private getDefaultStateFor(person: Person): EditCreatePersonStoreState
    {
        return {
            draft: perparePersonDraft(person),
            divisions: [],
        };
    }
}

function assertString(value: string, paramName: string): string
{
    assertTrue(typeof value === 'string', `${paramName} has to be non null string`);
    return value;
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Person/EditCreatePersonStore.ts